import React, { useState, useEffect } from "react";
import CreateStyle from "./Wrapper";
import {
  MdOutlineAddCircleOutline,
  MdOutlineDownloadDone,
  MdArrowDropDownCircle,
  MdRadioButtonUnchecked,
  MdRadioButtonChecked,
  MdPlusOne,
} from "react-icons/md";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  IconButton,
  Button,
} from "@material-ui/core";
// time
import DateMomentUtils from "@date-io/moment"; // choose your lib
import {
  DatePicker,
  DateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
// time
import {
  getCategory,
  getTag,
  setCategory_ToData,
  setChildData,
  setData,
  token,
} from "../../API";
import FileUpload from "../../Components/FileUpload";
import CreateTag from "../../Components/CreateTag";
import CreateCat from "../../Components/CreateCat";
import ModalKoinot from "../../Components/Modal";
// editor
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import FileUploadChild from "../../Components/FileUploadCHild";
// toast
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
// lotin kiril
import Transliterator from "../../KiriLatin";

const KLconverter = new Transliterator();
// console.log(cyrillicWord);
// KLconverter.toCyrillic("g'arb va g'arq'va o'roq")

const Create = () => {
  // -------------important------------
  const [important, setImportant] = useState(false);
  // ----------------tags------------
  const [tags, setTag] = useState([]);
  const [rec, setRec] = useState([]);
  const [tagBoolean, setTagBoolean] = useState("d-none");

  const getTags = async () => {
    let recTags = await getTag();
    setRec(recTags.data.objectKoinot);
  };

  const getCats = async () => {
    let reccats = await getCategory();
    setCats(reccats.data.objectKoinot);
  };
  useEffect(() => {
    getTags();
    getCats();
  }, []);

  const setTags = (id) => {
    let recArray = [...rec];
    const oneTag = recArray.filter((v) => v.id == id);
    let array = [...tags, oneTag[0]];
    setTag(array);

    let recarray = [...rec];
    let item = recarray.find((e) => e.id == id);
    recarray.splice(rec.indexOf(item), 1);

    setRec(recarray);
  };

  const returnTags = (id) => {
    // qowilgan taglardan idga togri keladigani olib bazdan keganlagan qowildi
    let tagArray = [...tags];
    const oneTag = tagArray.filter((v) => v.id == id)[0];
    let array = [...rec];
    array.unshift(oneTag);
    setRec(array);

    // qowilgan taglardan id-ga tori keladigani olib tawlandi
    let tagsarray = [...tags];
    let index = tags
      .map((x) => {
        return x.id;
      })
      .indexOf(id);
    tagsarray.splice(index, 1);
    setTag(tagsarray);
  };

  const addNewTag = (value) => {
    let array = [...tags, value];
    setTag(array);
    setTagBoolean("d-none");
  };
  const viewBooleanNewtag = () => {
    if (tagBoolean == "d-none") {
      setTagBoolean("d-block");
    } else {
      setTagBoolean("d-none");
    }
  };
  // ----------------tags--------------

  // -----------------cats-------------
  // categories
  const [cats, setCats] = useState([]);
  const [category, setCategory] = useState(1);
  const [catBoolean, setCatBoolean] = useState("d-none");
  const [ccategory, setCCategory] = useState([]);
  const [childCat, setChildCat] = useState(1);
  const [ccategory_s, setCCategory_s] = useState([]);
  const [childCat_s, setChildCat_s] = useState(1);
  const [categ, setCateg] = useState(1);

  const setCatBooleanHandle = () => {
    if (catBoolean == "d-none") {
      setCatBoolean("d-block");
    } else {
      setCatBoolean("d-none");
    }
  };

  // select
  // const selectCat = (id, path) => {
  //   if (path == "f_child") {
  //     setCategory(id);
  //     let childs = cats.filter((v) => v.parentCategory == id);
  //     setCCategory(childs);
  //   }
  //   if (path == "s_child") {
  //     setChildCat(id);
  //     let childs = cats.filter((v) => v.parentCategory == id);
  //     setCCategory_s(childs);
  //   }
  // };

  // create new tags and cats

  const addNewCat = () => {
    getCats();
    setCatBoolean("d-none");
  };

  // ---------time ------
  const [evTime, setEvTime] = useState(null);
  const [viewTime, setViewTime] = useState(null);

  // ----------link-----------
  const [link, setLink] = useState("");

  // ---------img id---------
  const [img, setImg] = useState(null);
  const [imgBool, setImgBool] = useState(false);
  const [clearImgBool, setClearImgBool] = useState(false);

  const pictureId = (value) => {
    setImg(value.data.object[0].fileId);
  };

  // upload by draftjs
  const uploadImageCallBack = (file) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        "http://164.90.236.174:1988/koinot/attachment/uploadPhotoFileList/NEWS_CHILD?requestMethod=POST"
      );
      xhr.setRequestHeader("Authorization", `Bearer ${token}`);
      const data = new FormData();
      data.append("image", file);
      xhr.send(data);
      xhr.addEventListener("load", () => {
        const response = JSON.parse(xhr.responseText);
        console.log(response.object[0].link);
        resolve({
          data: {
            link: response.object[0].link,
          },
        });
      });
      xhr.addEventListener("error", () => {
        const error = JSON.parse(xhr.responseText);
        console.log(error);
        reject(error);
      });
    });
  };

  const [uzTitle, setUztitle] = useState("");
  const [uzText, setUztext] = useState(EditorState.createEmpty());
  const [engTitle, setEngtitle] = useState("");
  const [engText, setEngtext] = useState(EditorState.createEmpty());
  const [ruTitle, setRutitle] = useState("");
  const [ruText, setRutext] = useState(EditorState.createEmpty());
  const [uzkTitle, setUzkitle] = useState("");
  const [uzkText, setUzktext] = useState(EditorState.createEmpty());

  // paste
  const [paste, setPaste] = useState(false);
  const CPFunction = (content) => {
    return content;
  };
  const KirilConverter = (lang) => {
    if (lang == "k") {
      console.log("-----------------------");
      console.log(uzText.getCurrentContent().getPlainText());
      console.log(
        KLconverter.latin_krill(uzText.getCurrentContent().getPlainText())
      );
      setUzktext(
        EditorState.createWithContent(
          ContentState.createFromText(
            KLconverter.latin_krill(uzText.getCurrentContent().getPlainText())
          )
        )
      );
      setUzkitle(KLconverter.latin_krill(uzTitle));
    } else {
      setUztext(
        EditorState.createWithContent(
          ContentState.createFromText(
            KLconverter.krill_latin(uzkText.getCurrentContent().getPlainText())
          )
        )
      );
      setUztitle(KLconverter.krill_latin(uzkTitle));
    }
  };

  // -----------finish --------
  const [modal, setModal] = useState("d-none");
  const [modalContent, setModalConent] = useState("");
  const [boolToChild, setBoolToChild] = useState("table-row");
  const [poster, setPoster] = useState(null);
  // const [confirm, setConfirm] = useState(false);

  // const confirmRes = (boolean) => {
  //   setConfirm(boolean);
  // };
  const closeModal = (val, data) => {
    setModal(val);
  };

  const finallyResult = () => {
    const setupModal = (value, data) => {
      setModal(value);
      if (data !== "child") setPoster(data);
    };
    const contentModal = (value) => {
      setModalConent(value);
    };
    const cleanFields = () => {
      setUztitle("");
      setUztext(EditorState.createEmpty());
      setUzkitle("");
      setUzktext(EditorState.createEmpty());
      setEngtitle("");
      setEngtext(EditorState.createEmpty());
      setRutitle("");
      setRutext(EditorState.createEmpty());
      setTag([]);
      getTags();
      setCategory(1);
      setLink("");
      setEvTime(null);
      setViewTime(null);
      setCCategory([]);
      setCCategory_s([]);
      setCateg(null);
    };
    // if (uzText !== "" && uzTitle !== "" && uzkText !== "" && uzkTitle !== "") {
    if (poster !== null) {
      let object = {
        fileId: img,
        link: link,
        newsId: poster.id,
        textEn: draftToHtml(convertToRaw(engText.getCurrentContent())),
        textRu: draftToHtml(convertToRaw(ruText.getCurrentContent())),
        textUz: draftToHtml(convertToRaw(uzText.getCurrentContent())),
        textUzK: draftToHtml(convertToRaw(uzkText.getCurrentContent())),
        titleUzK: uzkTitle,
        titleEn: engTitle,
        titleRu: ruTitle,
        titleUz: uzTitle,
      };
      setChildData(object);
      setClearImgBool(false);
      // setData(object, 'newsChild', setupModal, contentModal)
      let confir = confirm("Yana tarkib qo'shasizmi ?");
      if (confir) {
        setImg(null);
        setClearImgBool(true);
        cleanFields();
      } else {
        setPaste(false);
        CPFunction(true);
        setBoolToChild("table-row");
        cleanFields();
        setPoster(null);
        setClearImgBool(true);
        setImg(null);
        setImgBool(false);
      }
    } else {
      let objectKoinot = {
        attachmentId: img,
        categoryId: categ,
        tagIds: tags.map((v) => v.id),
        status: important === true ? "IMPORTANT" : "UNIMPORTANT",
        link: link,
        textEn: draftToHtml(convertToRaw(engText.getCurrentContent())),
        textRu: draftToHtml(convertToRaw(ruText.getCurrentContent())),
        textUz: draftToHtml(convertToRaw(uzText.getCurrentContent())),
        textUzK: draftToHtml(convertToRaw(uzkText.getCurrentContent())),
        timeToView: viewTime,
        eventTime: evTime,
        titleEn: engTitle,
        titleRu: ruTitle,
        titleUz: uzTitle,
        titleUzK: uzkTitle,
      };
      if (img !== null) {
        const PermissionChild = async () => {
          await setData(objectKoinot, "news", setupModal, contentModal);
          let childBool = confirm(
            "Yangilikning ichki tarkibini joylashtirasizmi?"
          );
          if (childBool) {
            setPaste(true);
            CPFunction(true);
            setBoolToChild("d-none");
            setClearImgBool(true);
            setImg(null);
            setImgBool("d-block");
            cleanFields();
          } else {
            cleanFields();
            setPoster(null);
            setClearImgBool(true);
            setImg(null);
          }
        };
        PermissionChild();
      } else {
        setModalConent("Rasm joylashtiring");
        setModal("d-block");
      }
    }
    // }
    //  else {
    //   toast.error("Maydonlarni to'liq belgilang");
    // }
  };
  return (
    <CreateStyle>
      <div className=" text-center w-100 mb-5">
        <h4 className="">Yangi post qo'yish</h4>
      </div>
      <table className="table table-hover">
        <thead>
          <tr>
            <th scope="col">Key</th>
            <th scope="col">Value</th>
          </tr>
        </thead>
        <tbody>
          {/* status */}

          <tr className={boolToChild}>
            <td className="p-3">
              <label className="fw-bold" htmlFor="titleUz">
                Status
              </label>
            </td>
            <td className="max-width">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  defaultValue={important}
                  value={important}
                  label={"Statusni tanlang"}
                  onChange={(e) => {
                    setImportant(e.target.value);
                  }}
                >
                  <MenuItem value={false}>Dolzarb emas</MenuItem>
                  <MenuItem value={true}>Dolzarb</MenuItem>
                </Select>
              </FormControl>
            </td>
          </tr>
          {/* /status */}

          {/* fields */}
          <tr>
            <td className="p-3">
              <label className="fw-bold" htmlFor="titleUz">
                Title Uz
              </label>

              <label className="fw-bold d-block my-2" htmlFor="textUz">
                Text Uz
              </label>
              <br />
              <br />
              <Button
                onClick={() => KirilConverter("k")}
                variant="contained"
                color="primary"
                component="span"
              >
                Kiril matniga nusxalash
              </Button>
            </td>
            <td className="max-width">
              <div className="form-group w-100">
                <textarea
                  className="form-control"
                  id="titleUz"
                  value={uzTitle}
                  onChange={(e) => setUztitle(e.target.value)}
                  rows="1"
                ></textarea>
              </div>
              <div className="form-group w-100 my-2">
                <Editor
                  handlePastedText={CPFunction}
                  editorState={uzText}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  toolbar={{
                    image: {
                      uploadCallback: uploadImageCallBack,
                    },
                    options: [
                      "inline",
                      "blockType",
                      "image",
                      "list",
                      "textAlign",
                      "link",
                      "history",
                    ],
                  }}
                  onEditorStateChange={(e) => {
                    setUztext(e);
                  }}
                />
              </div>
            </td>
          </tr>
          {/*  */}
          <tr>
            <td className="p-3">
              <label className="fw-bold" htmlFor="titleuzk">
                Uz (kiril) title
              </label>

              <label className="fw-bold d-block my-2">Uz (kiril) text</label>

              <br />
              <br />
              <Button
                onClick={() => KirilConverter("l")}
                variant="contained"
                color="primary"
                component="span"
              >
                Lotin matniga nusxalash
              </Button>
            </td>
            <td>
              <div className="form-group w-100">
                <textarea
                  className="form-control"
                  id="titleuzk"
                  value={uzkTitle}
                  onChange={(e) => setUzkitle(e.target.value)}
                  rows="1"
                ></textarea>
              </div>
              <div className="form-group w-100 my-2">
                <Editor
                  handlePastedText={CPFunction}
                  editorState={uzkText}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  toolbar={{
                    image: {
                      uploadCallback: uploadImageCallBack,
                    },
                    options: [
                      "inline",
                      "blockType",
                      "image",
                      "list",
                      "textAlign",
                      "link",
                      "history",
                    ],
                  }}
                  onEditorStateChange={(e) => {
                    setUzktext(e);
                  }}
                />
              </div>
            </td>
          </tr>
          {/*  */}

          <tr>
            <td className="p-3">
              <label className="fw-bold" htmlFor="titleEng">
                Title Eng
              </label>

              <label className="fw-bold d-block my-2" htmlFor="textEng">
                Text Eng
              </label>
            </td>
            <td>
              <div className="form-group w-100">
                <textarea
                  className="form-control"
                  id="titleEng"
                  value={engTitle}
                  onChange={(e) => setEngtitle(e.target.value)}
                  rows="1"
                ></textarea>
              </div>
              <div className="form-group w-100 my-2">
                <Editor
                  handlePastedText={CPFunction}
                  editorState={engText}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  toolbar={{
                    image: {
                      uploadCallback: uploadImageCallBack,
                    },
                    options: [
                      "inline",
                      "blockType",
                      "image",
                      "list",
                      "textAlign",
                      "link",
                      "history",
                    ],
                  }}
                  onEditorStateChange={(e) => {
                    setEngtext(e);
                  }}
                />
              </div>
            </td>
          </tr>
          {/*  */}
          <tr>
            <td className="p-3">
              <label className="fw-bold" htmlFor="titleRu">
                Title Ru
              </label>

              <label className="fw-bold d-block my-2" htmlFor="textRu">
                Text Ru
              </label>
            </td>
            <td>
              <div className="form-group w-100">
                <textarea
                  className="form-control"
                  id="titleRu"
                  value={ruTitle}
                  onChange={(e) => setRutitle(e.target.value)}
                  rows="1"
                ></textarea>
              </div>
              <div className="form-group w-100 my-2">
                <Editor
                  handlePastedText={CPFunction}
                  editorState={ruText}
                  wrapperClassName="demo-wrapper"
                  editorClassName="demo-editor"
                  toolbar={{
                    image: {
                      uploadCallback: uploadImageCallBack,
                    },
                    options: [
                      "inline",
                      "blockType",
                      "image",
                      "list",
                      "textAlign",
                      "link",
                      "history",
                    ],
                  }}
                  onEditorStateChange={(e) => {
                    setRutext(e);
                  }}
                />
              </div>
            </td>
          </tr>

          {/* texts end */}
          {/*  link*/}
          <tr>
            <td className="p-3">
              <label className="fw-bold" htmlFor="link">
                Link
              </label>
            </td>
            <td>
              <div className="form-group w-100">
                <textarea
                  className="form-control"
                  id="link"
                  value={link}
                  onChange={(e) => setLink(e.target.value)}
                  rows="1"
                ></textarea>
              </div>
            </td>
          </tr>
          {/*  link end*/}

          {/* tags -------- DON'T TOUCH IT---------- */}
          <tr className={boolToChild}>
            <td className="p-3">
              <label className="fw-bold" htmlFor="tag">
                Add tags
              </label>
            </td>
            <td className="max-width">
              <p className="fw-bold m-0">Postga qo'shilgan teglar</p> <br />
              <div className="d-flex flex-wrap">
                {tags.length !== 0
                  ? tags.map((v, i) => {
                      return (
                        <div
                          key={i}
                          onClick={() => returnTags(v.id)}
                          className="badge badge-pill badge-primary d-flex badge-border-suc border-info text-info"
                        >
                          <h6 className="m-0">{v.textUz}</h6>
                          <h6 className="m-0">
                            <MdOutlineDownloadDone className="ms-2" />
                          </h6>
                        </div>
                      );
                    })
                  : "hali teg qo'shmadingiz"}
              </div>
              <hr />
              {/* invisible */}
              <button
                className="btn btn-info"
                onClick={() => viewBooleanNewtag()}
              >
                Yangi tag qo'shish
              </button>
              <span className={tagBoolean}>
                <CreateTag callback={addNewTag} />
              </span>
              {/* /invisible */}
              <hr />
              <p> Bazada bor teglar</p>
              <div className="d-flex flex-wrap">
                {rec != []
                  ? rec.map((v, i) => {
                      return (
                        <span
                          key={i}
                          className="
                      badge
                      badge-primary
                      badge-border-suc
                      text-success
                      d-flex p-2"
                          onClick={() => setTags(v.id)}
                        >
                          <h6 className="m-0">{v.textUz}</h6>
                          <h6 className="m-0">
                            <MdOutlineAddCircleOutline className="ms-2" />
                          </h6>
                        </span>
                      );
                    })
                  : ""}
              </div>
            </td>
          </tr>
          {/* tags -------- DON'T TOUCH IT---------- */}

          {/* categories ---------- DON'T TOUCH IT----------*/}
          <tr className={boolToChild}>
            <td className="p-3">
              <p className="fw-bold">Kategoriyani tanlang</p>
            </td>

            <td>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Categories
                </InputLabel>
                <Select
                  MenuProps={{
                    anchorOrigin: {
                      vertical: "top",
                      horizontal: "left",
                    },
                    getContentAnchorEl: null,
                  }}
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  defaultValue={categ}
                  value={categ}
                  label={
                    cats.length != 0 ? cats[0].textUz : "Kategoriyalar yo'q"
                  }
                  onChange={(e) => {
                    setCateg(e.target.value);
                  }}
                >
                  {cats.map((v, i) => (
                    <MenuItem value={v.id} key={i}>
                      {v.textUz}
                      {/* <IconButton
                          onClick={() => setCateg(v.id)}
                          color={v.id == categ ? "secondary" : "default"}
                        >
                          {categ == v.id ? (
                            <MdRadioButtonChecked />
                          ) : (
                            <MdRadioButtonUnchecked />
                          )}
                        </IconButton> */}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* childs
              {ccategory.length !== 0 ? (
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-selectb">
                    Child categories
                  </InputLabel>
                  <Select
                    labelId="demo-simple-selectb"
                    id="demo-simple-selects"
                    defaultValue={childCat}
                    value={childCat}
                    onChange={(e) => {
                      selectCat(e.target.value, "s_child");
                    }}
                  >
                    {ccategory.map((v, i) => (
                      <MenuItem value={v.id} key={i}>
                        {v.textUz}
                        <IconButton
                          onClick={() => setCateg(v.id)}
                          color={v.id == categ ? "secondary" : "default"}
                        >
                          {categ == v.id ? (
                            <MdRadioButtonChecked />
                          ) : (
                            <MdRadioButtonUnchecked />
                          )}
                        </IconButton>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                ""
              )}
              {ccategory_s.length !== 0 && ccategory.length !== 0 ? (
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-selectb">
                    Child categories 2
                  </InputLabel>
                  <Select
                    labelId="demo-simple-selectb"
                    id="demo-simple-selects"
                    defaultValue={childCat_s}
                    value={childCat_s}
                    onChange={(e) => {
                      setCateg(e.target.value);
                      setChildCat_s(e.target.value);
                    }}
                  >
                    {ccategory_s.map((v, i) => (
                      <MenuItem value={v.id} key={i}>
                        {v.textUz}
                        <IconButton
                          onClick={() => setCateg(v.id)}
                          color={v.id == categ ? "secondary" : "default"}
                        >
                          {categ == v.id ? (
                            <MdRadioButtonChecked />
                          ) : (
                            <MdRadioButtonUnchecked />
                          )}
                        </IconButton>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              ) : (
                ""
              )} */}
              <br /> <br />
              <button
                className="btn btn-primary btn-sm"
                onClick={() => setCatBooleanHandle()}
              >
                Yangi kategoriya qo'shish
              </button>
              {/* invisible */}
              <span className={catBoolean}>
                <CreateCat callback={addNewCat} cats={cats} />
              </span>
              {/* /invisible */}
            </td>
          </tr>
          {/* categories -----------DON'T TOUCH IT-----------*/}

          {/* timepickers */}
          <tr className={boolToChild}>
            <td className="p-3">
              <p className="fw-bold">Event Time</p>
            </td>
            <td>
              <MuiPickersUtilsProvider utils={DateMomentUtils}>
                <DateTimePicker
                  value={evTime}
                  onChange={(e) => setEvTime(e.format("yyyy.MM.DD HH:mm"))}
                  autoOk
                  ampm={false}
                  label="Hodisa bo'lgan vaqti"
                  inputVariant="outlined"
                  format="yyyy.MM.DD HH:mm"
                />
              </MuiPickersUtilsProvider>
            </td>
          </tr>
          {/* timetoview */}
          <tr className={boolToChild}>
            <td className="p-3">
              <p className="fw-bold">Time to view</p>
            </td>
            <td>
              <MuiPickersUtilsProvider utils={DateMomentUtils}>
                <DateTimePicker
                  value={viewTime}
                  onChange={(e) => setViewTime(e.format("yyyy.MM.DD HH:mm"))}
                  autoOk
                  ampm={false}
                  label="Saytga ko'rinish vaqti"
                  inputVariant="outlined"
                  format="yyyy.MM.DD HH:mm"
                />
              </MuiPickersUtilsProvider>
            </td>
          </tr>
          {/* timepickers */}

          {/* imgUpload */}
          <tr>
            <td className="p-3">
              <p className="fw-bold">Photo</p>
            </td>
            <td>
              <div className={boolToChild}>
                <FileUpload
                  callback={pictureId}
                  clearBool={clearImgBool}
                  came={img !== null ? true : false}
                />
              </div>
              <div className={imgBool ? "d-block" : "d-none"}>
                <p className="fw-bold">Child</p>
                <FileUploadChild
                  callback={pictureId}
                  clearBool={clearImgBool}
                  came={img !== null ? true : false}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <button className="btn btn-primary w-100" onClick={finallyResult}>
        Submit
      </button>
      {/* modal */}
      <ModalKoinot
        display={modal}
        content={modalContent}
        callback={closeModal}
      />
      {/* toast */}
      <div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>

      {/* toast */}
    </CreateStyle>
  );
};
export default Create;



// WEBPACK FOOTER //
// ./src/Pages/Create/index.js